export class Container {
  workItems: [];
}
